<template>
  <AccordionInfoBox :height="40">
    <template #title>
          <span class="text-[13px]">
            Jak odebrać nagrodę?
          </span>
    </template>
    <template #default>
      <ul class="border-t border-zt-light flex flex-col text-white text-xs red-cross font-normal gap-y-2.5 pt-3">
        <li class="flex gap-x-[7px]">
          <svg class="min-w-3 min-h-3 translate-y-[2px]" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3.51562" y="2.48438" width="3.51475" height="3.51475" transform="rotate(-45 3.51562 2.48438)" fill="#FF4A5D"/>
            <rect x="3.51562" y="9.51562" width="3.51475" height="3.51475" transform="rotate(-45 3.51562 9.51562)" fill="#FF4A5D"/>
            <rect x="7.03125" y="6" width="3.51475" height="3.51475" transform="rotate(-45 7.03125 6)" fill="#FF4A5D"/>
            <rect y="6" width="3.51475" height="3.51475" transform="rotate(-45 0 6)" fill="#FF4A5D"/>
          </svg>
          <span>
            Aby otrzymać nagrodę, wchodzimy w: <span class="font-medium">MOJE KONTO</span> > <span class="font-medium">USTAWIENIA KONTA</span> >
            <a href="/ustawienia/#Bukmacherzy" class="no-default-style font-medium text-zt-red zt-hover cursor-pointer underline">MOI BUKMACHERZY</a> i uzupełniamy login/e-mail do konta, które Administrator przekaże do bukmacherów.
          </span>
        </li>
        <li class="flex gap-x-[7px]">
          <svg class="min-w-3 min-h-3  translate-y-[2px]" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3.51562" y="2.48438" width="3.51475" height="3.51475" transform="rotate(-45 3.51562 2.48438)" fill="#FF4A5D"/>
            <rect x="3.51562" y="9.51562" width="3.51475" height="3.51475" transform="rotate(-45 3.51562 9.51562)" fill="#FF4A5D"/>
            <rect x="7.03125" y="6" width="3.51475" height="3.51475" transform="rotate(-45 7.03125 6)" fill="#FF4A5D"/>
            <rect y="6" width="3.51475" height="3.51475" transform="rotate(-45 0 6)" fill="#FF4A5D"/>
          </svg>
          <span>Freebety przyznawane są zazwyczaj do 7 dni roboczych po ogłoszeniu wyników.</span>
        </li>
      </ul>
    </template>
  </AccordionInfoBox>
</template>

<script>
import AccordionInfoBox from "../AccordionInfoBox.vue";

export default {
  name: 'PrizesHowToGetRewardsInfo',
  components: {AccordionInfoBox}
}
</script>